<template>
  <HeaderBase>
    <div
      class="flex items-center shrink header-title w-1/5 cursor-pointer"
      @click="$router.push({
        name: 'services.categories',
      })">
      <span class="arrow arrow-l arrow-primary"></span>
      <b>Создание новой категории услуг</b>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
    </div>
  </HeaderBase>
</template>

<script>
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
};
</script>
